// import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";


export const BRAND = "#865798";
export const BRAND_LIGHT = "#a06cb5";
export const BRAND_DARK = "#5e3a6b";

export const NAV_LINKS = ["Home", "About", "Gallery", "Team", "Blog", "Contact"];



// export const SOCIAL_LINKS = [
//   { 
//     name: "Facebook", o
//     url: "https://www.facebook.com/profile.php?id=100069842474477&mibextid=ZbWKwL", 
//     icon: FaFacebook 
//   },
//   // { 
//   //   name: "Instagram", 
//   //   url: "https://instagram.com/bethsedaorphanage", 
//   //   icon: FaInstagram 
//   // },
//   // { 
//   //   name: "Twitter/X", 
//   //   url: "https://twitter.com/bethsedaorphanage", 
//   //   icon: FaTwitter 
//   // },
//   // { 
//   //   name: "YouTube", 
//   //   url: "https://youtube.com/@bethsedaorphanage", 
//   //   icon: FaYoutube 
//   // },
// ];

export const CONTACT = {
  phone: "+234 907 565 3657, +234 905 719 9221, +39389001226",
    phone1: "+234 907 565 3657",
    phone2: "+234 905 719 9221",
    phone3: "+39389001226",

  // whatsapp: "+234 803 000 0000",
  email: "goodmorningjesus22@gmail.com",
  address: "Opposite Chinese Iron company, off Pipeline Road, Ogua Community, Upper Sakponba Road, Benin City, Edo State, Nigeria.",
  // cac: "RC-1234567",
  // cacIssued: "March 2018",
};

export const TEAM = [
  {
    name: "EVANG. EKATA BARTHOLOMEN",
    role: "CEO & Founder",
    isCEO: true,
    board: "Board Chair, Bethseda Foundation",
    speech:
      "We produce safe, nutritious, and high-quality agricultural products through modern greenhouse and open-field farming practices, driven by sustainability, innovation, and operational excellence. Come partner with us.",
    photo: '/EVANG. EKATA BARTHOLOMEN.png',
    initials: "",
  },
  { name: "MRS. EKATA EXCEL JESU-ORHOME", role: "Board Secretary", photo:'/MRS. EKATA EXCEL JESU-ORHOME.png', initials: "" },
    { name: "OLUMOKOR AYODELE GABRIEL", role: "Admin/Accountant", photo: '/OLUMOKOR AYODELE GABRIEL.png', initials: "" },
  { name: "Obed Ekenechukwu Onwe", role: "Media Director", photo: '/Obed Ekenechukwu Onwe.jpg', initials: "" },
  // { name: "Mr. Seun Adebayo", role: "Board Member – Education", photo: null, initials: "SA" },
];

export const GALLERY_SLOTS = Array.from({ length: 3 }, (_, i) => ({
  id: i + 1,
  label: `Gallery Photo ${i + 1}`,
  src:[
    "/MR NWANKWO RANSOM - FASHION DESIGNING INSTRUCTOR at Bethesda.png",
    "/Feeding programme in action at Bethesda.png",
    "/BETHESDA ORPHGANAGE HOME WARDS AT  EMMANUEL’S MATRICULATION CEREMONY.png"
  ],
  caption: [
    "MR NWANKWO RANSOM - FASHION DESIGNING INSTRUCTOR",
    "Feeding programme in action",
    "BETHESDA ORPHGANAGE HOME WARDS AT  EMMANUEL’S MATRICULATION CEREMONY"
  ][i],
}));

export const BLOG_POSTS_DEFAULT = [
  // {
  //   id: 1,
  //   slug: "children-scored-top-marks-waec-2024",
  //   title: "How Our Children Scored Top Marks in WAEC 2024",
  //   date: "2024-11-15",
  //   author: "Admin",
  //   category: "Education",
  //   excerpt:
  //     "Three of our children achieved distinctions in the 2024 WAEC examinations, proving that love and support can unlock extraordinary potential.",
  //   body: "We are overjoyed to announce that three children from Bethseda Orphanage Home achieved outstanding distinctions in the 2024 WAEC examinations. Their success is a testament to the dedication of our teaching staff, the generosity of our sponsors, and — most importantly — the resilience of the children themselves. This achievement inspires us to keep investing in education as the most powerful tool for transformation.",
  //   image: null,
  // },
  // {
  //   id: 2,
  //   slug: "medical-outreach-free-health-check-200-children",
  //   title: "Medical Outreach: Free Health Check for 200 Children",
  //   date: "2024-10-02",
  //   author: "Dr. Chukwuemeka Eze",
  //   category: "Health",
  //   excerpt:
  //     "Our quarterly medical outreach provided free health screenings, vaccinations, and dental care to over 200 children in our care and the surrounding community.",
  //   body: "On October 2nd, 2024, Bethseda partnered with Lagos University Teaching Hospital to provide free comprehensive health screenings. Over 200 children received dental checks, eye tests, vaccinations, and nutritional assessments. We are grateful to the volunteer medical team who gave their Saturday to serve these wonderful children.",
  //   image: null,
  // },
  // {
  //   id: 3,
  //   slug: "new-library-block-officially-commissioned",
  //   title: "New Library Block Officially Commissioned",
  //   date: "2024-08-20",
  //   author: "Admin",
  //   category: "Infrastructure",
  //   excerpt:
  //     "Thanks to the generosity of our donors, we commissioned a brand-new 1,000-book library giving our children access to knowledge like never before.",
  //   body: "Our new library block was officially commissioned on August 20th, 2024. Stocked with over 1,000 carefully selected books — from academic textbooks to storybooks and encyclopaedias — the library is already buzzing with curious young minds. We thank all donors who made this dream a reality.",
  //   image: null,
  // },
];

/** Generates a URL-safe slug from a title */
export function slugify(title) {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}